import axios from 'axios'
import AuiToast from '../../assets/js/aui-toast'

const isTest = false

function extensionPath() {
  return isTest ? 'test/' : ''
}
/**
 * 获取DTU产品列表
 */
const getDtuProductList = async () => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) { })
  return axios.post(`/api/jvcom/dtu/${extensionPath()}manager/product-info/query`, {})
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 获取产品对应的从机协议
 */
const getProtocolByProduct = async (productId) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) { })
  return axios.post(`/api/jvcom/dtu/${extensionPath()}accessor/product-protocol-rel/find-protocol-by-product-id/${productId}`)
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 获取协议分组列表
 */
const getDtuGroupList = async (protocolId) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) { })
  return axios.post(`/api/jvcom/dtu/${extensionPath()}accessor/data-point-group/query`, {
    protocolId
  })
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 获取分组数据点列表
 */
const getDtuDataPointList = async (protocolId, groupId) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) { })
  return axios.post(`/api/jvcom/dtu/${extensionPath()}accessor/data-point/query`, {
    protocolId,
    groupId
  })
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 下发DTU协议
 */
const downProtocolDtu = async (sn, protocolId, groupId, writeDownData) => {
  console.log('下发DTU协议', sn, protocolId, writeDownData)
  let params = {
    deviceSns: [sn],
    mqttModel: 'DEVICE_SENSOR',
    protocolType: 'PCS_RS485_TRANSMIT_DATA_READ',
    waitReply: true,
    timeout: 2000,
    transmitData: {
      protocolId,
      groupId,
      readWriteType: 'READ',
    }
  }
  if (writeDownData) {
    params.transmitData.readWriteType = 'WRITE',
      params.transmitData.dataSetDown = writeDownData
  }
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) { })
  return axios.post(`/api/jvcom/dtu/${extensionPath()}accessor/processor-protocol/down-protocol`, params)
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 查询当前数据记录
 */
const deviceStatusCurrent = async (snHex, protocolId, groupId) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) { })
  return axios.post(`/api/jvcom/dtu/${extensionPath()}accessor/device-point-status-record/current-data`, {
    snHex,
    protocolId,
    groupId
  })
    .then(res => {
      AuiToast.hide()
      return res
    })
}

/**
 * 查询历史数据记录
 */
const deviceStatusHistory = async (snHex, protocolId, groupId, dataPointKey, beginDateTime, endDateTime) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) { })
  return axios.post(`/api/jvcom/dtu/${extensionPath()}accessor/device-point-status-record/record-data`, {
    snHex,
    protocolId,
    groupId,
    dataPointKey,
    beginDateTime,
    endDateTime
  })
    .then(res => {
      AuiToast.hide()
      return res
    })
}

/**
 * 查询SN号下的从机设备
 */
const getSlaveMoteBySn = async (sn) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) { })
  return axios.post('/api/jvcom/dtu/manager/solar-sub-device/query', {
    sn
  })
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 根据SN号查询从机数据
 */
const getSlaveMoteByDetail = async (sn, type = 'WATER_QUALITY_SENSOR') => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) { })
  return axios.post('/api/jvcom/dtu/manager/solar-sub-device-status-record/detail', {
    sn,
    type
  })
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 下发水质更新命令
 */
const sendWaterQualityCommand = async (sn) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) { })
  return axios.post('/api/jvcom/dtu/manager/solar-sub-device/down-water-quality', [sn])
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 通过Sn号查询子设备
 */
const solarMoteExtension = async (sn) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) { })
  return axios.get(`/api/jvcom/dtu/manager/solar-mote-extension/query-by-sn/${sn}`)
    .then(res => {
      AuiToast.hide()
      return res
    })
}


const dtu = {
  getDtuProductList,
  deviceStatusCurrent,
  getDtuGroupList,
  getDtuDataPointList,
  downProtocolDtu,
  getProtocolByProduct,
  deviceStatusHistory,
  getSlaveMoteBySn,
  getSlaveMoteByDetail,
  sendWaterQualityCommand,
  solarMoteExtension
}
export default dtu
